import React from 'react';

export default React.memo(function Radio(props) {
  return (
    <input type={'radio'} {...props} />
  );
})
